module.exports = __webpack_public_path__ + "img/window.bf60da15.svg";